<app-layout-dialogheader1 [title]="title" [titlesub]="titlesub" [classtype]="'bluehead'" mat-dialog-title>
</app-layout-dialogheader1>

<mat-dialog-content>
    <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
        <div class="container-fluid" style="padding-top: 24px;">
            <div class="form-group row">
                <div class="col-sm-12" style="padding: 0px;">
                    <label class="form-label" for="myslider">{{range_title}}</label>
                    <div class="slider-container">
                        <div class="zoom min">{{range_min }}</div>
                        <div class="slider">
                            <p-slider  id="myslider" [(ngModel)]="rangeValues" [range]="true" [step]="slider_step"
                            [max]="slider_max" [min]="slider_min" [ngModelOptions]="{standalone: true}"></p-slider>
                        </div>
                        <div
                            class="zoom max">{{range_max}}</div>
                    </div>
                    <div class="range-description">
                        <p>
                            Range selected from {{rangeValues[0] | number:'1.1-2'}}  to  {{rangeValues[1] | number:'1.1-2'}}
                        </p>
                        
                    </div>
                    <div *ngIf="comments">
                        <i class="fas fa-info-circle" ></i>
                    </div>
                </div>
            </div>
        </div>
</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end">
    <button mat-raised-button type="button" (click)="okaction()" [disabled]="!isvalid()"
        class="btn btn-success pull-right">{{okActionText}}</button>
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>